import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { EmailOutlined, PhoneOutlined } from '@mui/icons-material';

const EntryDetailsComponent = () => {
    const { selectedLead } = useSelector((state: RootState) => state.lead);
    const formData = JSON.parse(selectedLead?.form_data as string || '{}');
    return <Box minHeight="60vh">
        <Box display="flex" alignItems="start" flexWrap="wrap" gap={5}>
            <Box display="flex" alignItems="center" gap={1}>
                <EmailOutlined fontSize="small" />
                <Typography variant="subtitle1" color="textSecondary">
                    - {selectedLead?.email}
                </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
                <PhoneOutlined fontSize="small" />
                <Typography variant="subtitle1" color="textSecondary">
                    - {selectedLead?.phone}
                </Typography>
            </Box>
        </Box>
        <Typography variant="h5" mt={2}>More Details</Typography>
        <List>
            {formData && typeof formData === 'object' && !Array.isArray(formData) &&
                Object.keys(formData).length && Object.entries(formData).map(([key, field]: [string, unknown]) => {
                    let label = key;
                    let value = '';
                    if (field && typeof field === 'object' && 'label' in field && 'value' in field) {
                        // eslint-disable-next-line prefer-destructuring
                        label = String(field.label);
                        value = (field.value && typeof field.value !== 'object')
                        ? String(field.value)
                        : Array.isArray(field.value)
                            ? field.value.join(', ')
                            : '';
                    } else {
                        // Fallback for primitive fields like timestamp
                        value = String(field);
                    }
                    return <ListItem key={key} alignItems="flex-start">
                        <ListItemText
                            primary={<strong>{label}</strong>}
                            secondary={
                                // key.toLowerCase().includes('attachment')
                                //     ? <Link href={value as string} target="_blank" rel="noopener noreferrer">{value as string}</Link>
                                //     :
                                    String(value)
                            }
                        />
                    </ListItem>;
            })}
            {formData && Array.isArray(formData) && formData.map(({ name, values }) => (
                <ListItem key={name} alignItems="flex-start">
                <ListItemText
                    primary={<strong>{name}</strong>}
                    secondary={Array.isArray(values)
                    ? values.join(', ')
                    : values}
                />
                </ListItem>
            ))}
        </List>
    </Box>;
};

export default EntryDetailsComponent;